<script lang="ts">
  import { Icon, ListAlertType } from '$shared/components';

  interface Props {
    icon?: string;
    key?: string;
    type?: ListAlertType;
    value?: import('svelte').Snippet;
    children?: import('svelte').Snippet;
  }

  let {
    icon = '',
    key = '',
    type = ListAlertType.Default,
    value,
    children
  }: Props = $props();
</script>

<div data-cy="alert-list" class="list-alert {type}">
  <div class="alert-item-content">
    <div class="label-wrap">
      <div class="icon" class:show={!!icon}><Icon value={icon} /></div>
      {#if key}
        <div data-cy={`${key}-alert-k`} class="label">{key}</div>
      {/if}
    </div>
    {#if value}
      <div data-cy={`${key}-alert-v`} class="alert-value">
        {@render value?.()}
      </div>
    {/if}
  </div>
  {@render children?.()}
</div>

<style>
  .list-alert {
    background-color: var(--yellow);
    min-height: 44px;
    display: flex;
    justify-content: space-between;
  }
  .list-alert .alert-item-content {
    display: flex;
    align-items: flex-start;
    flex-basis: 90%;
  }
  .list-alert.added,
  .list-alert.addNewSection {
    background-color: var(--green-light);
  }
  .list-alert.updated,
  .list-alert.changeTo,
  .list-alert.licenseTypeChange,
  .list-alert.stateChange,
  .list-alert.changeToNewSection {
    background-color: var(--yellow);
  }
  .list-alert.removed {
    background-color: var(--red-light);
  }
  .label-wrap {
    display: flex;
    align-items: center;
    width: calc(150px + 16px);
    flex-shrink: 0;
    padding: 12px 16px;
  }
  .icon {
    display: none;
  }
  .icon.show {
    margin-right: 8px;
    display: flex;
    align-items: center;
  }
  .label {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
  }
  .alert-value {
    flex-basis: 85%;
    height: 100%;
  }
</style>
